import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DetectorsComponent} from './detectors/detectors.component';
import {RouterModule} from '@angular/router';
import {EditDetectorsComponent} from './edit-detectors/edit-detectors.component';
import {ShowDetectorsComponent} from './show-detectors/show-detectors.component';
import {NxCardModule} from '@allianz/ng-aquila/card';
import {NxIconModule} from '@allianz/ng-aquila/icon';
import {ComponentsModule} from '../../components/components.module';
import {NxHeadlineModule} from '@allianz/ng-aquila/headline';
import {NxGridModule} from '@allianz/ng-aquila/grid';
import {NxButtonModule} from '@allianz/ng-aquila/button';
import {NxFormfieldModule} from '@allianz/ng-aquila/formfield';
import {NxInputModule} from '@allianz/ng-aquila/input';
import {FormsModule} from '@angular/forms';
import {NxSwitcherModule} from "@allianz/ng-aquila/switcher";
import {TextFieldModule} from "@angular/cdk/text-field";
import {NxDataDisplayModule} from "@allianz/ng-aquila/data-display";
import {NxCopytextModule} from "@allianz/ng-aquila/copytext";
import {NxToolbarModule} from "@allianz/ng-aquila/toolbar";


@NgModule({
  declarations: [
    DetectorsComponent,
    EditDetectorsComponent,
    ShowDetectorsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NxCardModule,
    NxIconModule,
    ComponentsModule,
    NxHeadlineModule,
    NxGridModule,
    NxButtonModule,
    NxFormfieldModule,
    NxInputModule,
    FormsModule,
    NxSwitcherModule,
    TextFieldModule,
    NxDataDisplayModule,
    NxCopytextModule,
    NxToolbarModule,
  ]
})
export class DetectorModule {
}
